// Spec: docs/plans/frontend-stack.md §3.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SkinLoader } from './skin-loader';
import './skins/modern/styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <SkinLoader />
  </StrictMode>,
);
